// 2024 Hunter (SRD 5.2). Hunter's Prey grants one option at a time: the chosen option's feature is
// entitled only while `classState.ranger.huntersPrey.id` names it (see `choice` below).
const hunter = Object.freeze({
  id: 'hunter', definitionId: 'ranger:hunter', classId: 'ranger',
  name: 'Hunter', selectionLevel: 3,
  description: 'A Ranger who stalks dangerous prey and protects the world from it.',
  features: Object.freeze([
    {
      id: 'ranger:hunter:hunters-lore', name: "Hunter's Lore", level: 3,
      description: 'While a creature is marked by your Hunter’s Mark, you know whether that creature has any Immunities, Resistances, or Vulnerabilities, and if the creature has any, you know what they are.',
      presentation: { kind: 'passive' }, contracts: [],
    },
    {
      id: 'ranger:hunter:hunters-prey', name: "Hunter's Prey", level: 3,
      description: 'Choose Colossus Slayer or Horde Breaker. Whenever you finish a Short or Long Rest, you can replace the chosen option with the other one.',
      presentation: { kind: 'configuration' }, contracts: [],
    },
    {
      id: 'ranger:hunter:colossus-slayer', name: 'Colossus Slayer', level: 3,
      description: 'When you hit a creature with a weapon, the weapon deals an extra 1d8 damage to the target if it’s missing any of its Hit Points. You can deal this extra damage only once per turn.',
      presentation: { kind: 'attack-modifier' }, contracts: ['attack:on-hit'],
      choice: { key: 'huntersPrey', value: 'colossus-slayer' },
    },
    {
      id: 'ranger:hunter:horde-breaker', name: 'Horde Breaker', level: 3,
      description: 'Once on each of your turns when you make an attack with a weapon, you can make another attack with the same weapon against a different creature that is within 5 feet of the original target, that is within the weapon’s range, and that you haven’t attacked this turn.',
      presentation: { kind: 'attack-modifier' }, contracts: ['action-economy:extra-attack'],
      choice: { key: 'huntersPrey', value: 'horde-breaker' },
    },
    {
      id: 'ranger:hunter:defensive-tactics', name: 'Defensive Tactics', level: 7,
      description: 'Choose Escape the Horde or Multiattack Defense. Whenever you finish a Short or Long Rest, you can replace the chosen option with the other one.',
      presentation: { kind: 'configuration' }, contracts: [],
    },
    {
      id: 'ranger:hunter:superior-hunters-prey', name: "Superior Hunter's Prey", level: 11,
      description: 'Once per turn when you deal damage to a creature marked by your Hunter’s Mark, you can also deal that spell’s extra damage to a different creature you can see within 30 feet of the first creature.',
      presentation: { kind: 'attack-modifier' }, contracts: [],
    },
    {
      id: 'ranger:hunter:superior-hunters-defense', name: "Superior Hunter's Defense", level: 15,
      description: 'When you take damage, you can take a Reaction to give yourself Resistance to that damage and any other damage of the same type until the end of the current turn.',
      presentation: { kind: 'reaction' }, contracts: [],
    },
  ]),
});

export default hunter;
